import React, { useEffect, useId, useRef, useState } from 'react';
import { sendStockAccountingEmail } from '../api';
import VarietyEditorDialog from './varietyPricing/VarietyEditorDialog';

export default function StockAccountingEmailAction({ branchId, stockList }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const mounted = useRef(true);
  const formId = `stock-accounting-email-${useId().replace(/:/g, '')}`;
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);

  const send = async (event) => {
    event.preventDefault();
    if (busyRef.current || stockList.status !== 'completed') return;
    const recipient = email.trim();
    if (!recipient || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient)) {
      setError('Ingresa un correo electrónico válido.');
      return;
    }
    busyRef.current = true;
    setBusy(true);
    setError('');
    setSentTo('');
    try {
      await sendStockAccountingEmail(branchId, stockList.id, recipient);
      if (mounted.current) { setSentTo(recipient); setOpen(false); }
    } catch (err) {
      if (mounted.current) setError(err?.response?.data?.message || 'No se pudo enviar el correo. Puedes reintentar.');
    } finally {
      busyRef.current = false;
      if (mounted.current) setBusy(false);
    }
  };

  if (stockList.status !== 'completed') return null;
  return <div>
    <button type="button" className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700" onClick={() => { setError(''); setOpen(true); }}>
      Enviar PDF por correo
    </button>
    {sentTo && <p role="status" className="mt-2 text-sm text-emerald-700 break-all">PDF enviado a {sentTo}.</p>}
    {open && <VarietyEditorDialog
      eyebrow="Contabilidad" title="Enviar lista de stock por correo"
      description={stockList.name} onClose={() => setOpen(false)} busy={busy} closeLabel="Cerrar envío de correo"
      footerActions={<>
        <button type="button" disabled={busy} onClick={() => setOpen(false)} className="rounded-lg border border-slate-300 px-4 py-2 text-sm disabled:opacity-50">Cancelar</button>
        <button type="submit" form={formId} disabled={busy} className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white disabled:opacity-50">{busy ? 'Enviando…' : 'Enviar PDF'}</button>
      </>}
    >
      <form id={formId} onSubmit={send} className="space-y-4 p-4 sm:p-6">
        <p className="text-sm text-slate-600">El PDF incluye todos los artículos de esta lista: cantidades y formatos de compra, montos, datos de proveedores, pagos, saldos y gastos.</p>
        <div>
          <label htmlFor={`${formId}-recipient`} className="block text-sm font-semibold text-slate-800">Correo del destinatario</label>
          <input id={`${formId}-recipient`} name="email" type="email" inputMode="email" autoComplete="email" required maxLength={254}
            value={email} disabled={busy} onChange={(event) => { setEmail(event.target.value); setError(''); }}
            placeholder="contador@empresa.cl" aria-invalid={Boolean(error)} aria-describedby={error ? `${formId}-error` : undefined}
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 disabled:bg-slate-100" />
        </div>
        {error && <p id={`${formId}-error`} role="alert" className="text-sm text-red-700">{error}</p>}
      </form>
    </VarietyEditorDialog>}
  </div>;
}
